export const GET_MERCHANT_GROUP = "GET_MERCHANT_GROUP"
export const GET_MERCHANT_GROUP_SUCCESS = "GET_MERCHANT_GROUP_SUCCESS"
export const GET_MERCHANT_GROUP_FAIL = "GET_MERCHANT_GROUP_FAIL"
export const CLEAR_MERCHANT_GROUP = "CLEAR_MERCHANT_GROUP"

// Add New Merchant Group
export const ADD_NEW_MERCHANT_GROUP = "ADD_NEW_MERCHANT_GROUP"
export const ADD_NEW_MERCHANT_GROUP_SUCCESS = "ADD_NEW_MERCHANT_GROUP_SUCCESS"
export const ADD_NEW_MERCHANT_GROUP_FAIL = "ADD_NEW_MERCHANT_GROUP_FAIL"


// uploadBase64File
export const UPLOAD_BASE64_FILE = "UPLOAD_BASE64_FILE"
export const UPLOAD_BASE64_FILE_SUCCESS = "UPLOAD_BASE64_FILE_SUCCESS"
export const UPLOAD_BASE64_FILE_FAIL = "UPLOAD_BASE64_FILE_FAIL"

//Get Merchant Group Detail
export const GET_MERCHANT_GROUP_DETAIL = "GET_MERCHANT_GROUP_DETAIL"
export const GET_MERCHANT_GROUP_DETAIL_SUCCESS =
  "GET_MERCHANT_GROUP_DETAIL_SUCCESS"
export const GET_MERCHANT_GROUP_DETAIL_FAIL = "GET_MERCHANT_GROUP_DETAIL_FAIL"
export const CLEAR_MERCHANT_GROUP_DETAIL = "CLEAR_MERCHANT_GROUP_DETAIL"

// Merchant Group Communications
export const GET_MERCHANT_GROUP_COMMUNICATIONS =
  "GET_MERCHANT_GROUP_COMMUNICATIONS"
export const GET_MERCHANT_GROUP_COMMUNICATIONS_SUCCESS =
  "GET_MERCHANT_GROUP_COMMUNICATIONS_SUCCESS"
export const GET_MERCHANT_GROUP_COMMUNICATIONS_FAIL =
  "GET_MERCHANT_GROUP_COMMUNICATIONS_FAIL"
export const CLEAR_MERCHANT_GROUP_COMMUNICATIONS =
  "CLEAR_MERCHANT_GROUP_COMMUNICATIONS"

// Add/Update Merchant Group Communication
export const MANAGE_MERCHANT_GROUP_COMMUNICATION =
  "MANAGE_MERCHANT_GROUP_COMMUNICATION"
export const MANAGE_MERCHANT_GROUP_COMMUNICATION_SUCCESS =
  "MANAGE_MERCHANT_GROUP_COMMUNICATION_SUCCESS"
export const MANAGE_MERCHANT_GROUP_COMMUNICATION_FAIL =
  "MANAGE_MERCHANT_GROUP_COMMUNICATION_FAIL"

// Communication Channels Lookup

// Merchant Group Contacts
export const GET_MERCHANT_GROUP_CONTACTS = "GET_MERCHANT_GROUP_CONTACTS"
export const GET_MERCHANT_GROUP_CONTACTS_SUCCESS =
  "GET_MERCHANT_GROUP_CONTACTS_SUCCESS"
export const GET_MERCHANT_GROUP_CONTACTS_FAIL =
  "GET_MERCHANT_GROUP_CONTACTS_FAIL"
export const CLEAR_MERCHANT_GROUP_CONTACTS = "CLEAR_MERCHANT_GROUP_CONTACTS"

// Manage Merchant Group Contact
export const MANAGE_MERCHANT_GROUP_CONTACT = "MANAGE_MERCHANT_GROUP_CONTACT"
export const MANAGE_MERCHANT_GROUP_CONTACT_SUCCESS =
  "MANAGE_MERCHANT_GROUP_CONTACT_SUCCESS"
export const MANAGE_MERCHANT_GROUP_CONTACT_FAIL =
  "MANAGE_MERCHANT_GROUP_CONTACT_FAIL"

// Merchant Group Contact Communications
export const GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS =
  "GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS"
export const GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_SUCCESS =
  "GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_SUCCESS"
export const GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_FAIL =
  "GET_MERCHANT_GROUP_CONTACT_COMMUNICATIONS_FAIL"

// Manage Merchant Group Contact Communication
export const MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION =
  "MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION"
export const MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_SUCCESS =
  "MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_SUCCESS"
export const MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_FAIL =
  "MANAGE_MERCHANT_GROUP_CONTACT_COMMUNICATION_FAIL"

// Merchant Group Banking
export const GET_MERCHANT_GROUP_BANKING = "GET_MERCHANT_GROUP_BANKING"
export const GET_MERCHANT_GROUP_BANKING_SUCCESS = "GET_MERCHANT_GROUP_BANKING_SUCCESS"
export const GET_MERCHANT_GROUP_BANKING_FAIL = "GET_MERCHANT_GROUP_BANKING_FAIL"
export const CLEAR_MERCHANT_GROUP_BANKING = "CLEAR_MERCHANT_GROUP_BANKING"

// Merchant Group Banking Detail (List)
export const GET_MERCHANT_GROUP_BANKING_DETAIL = "GET_MERCHANT_GROUP_BANKING_DETAIL"
export const GET_MERCHANT_GROUP_BANKING_DETAIL_SUCCESS = "GET_MERCHANT_GROUP_BANKING_DETAIL_SUCCESS"
export const GET_MERCHANT_GROUP_BANKING_DETAIL_FAIL = "GET_MERCHANT_GROUP_BANKING_DETAIL_FAIL"
export const CLEAR_MERCHANT_GROUP_BANKING_DETAIL = "CLEAR_MERCHANT_GROUP_BANKING_DETAIL"

// Add New Merchant Group Banking
export const ADD_NEW_MERCHANT_GROUP_BANKING = "ADD_NEW_MERCHANT_GROUP_BANKING"
export const ADD_NEW_MERCHANT_GROUP_BANKING_SUCCESS = "ADD_NEW_MERCHANT_GROUP_BANKING_SUCCESS"
export const ADD_NEW_MERCHANT_GROUP_BANKING_FAIL = "ADD_NEW_MERCHANT_GROUP_BANKING_FAIL"

// Manage Merchant Group Banking (Activate/Deactivate)
export const MANAGE_MERCHANT_GROUP_BANKING = "MANAGE_MERCHANT_GROUP_BANKING"
export const MANAGE_MERCHANT_GROUP_BANKING_SUCCESS = "MANAGE_MERCHANT_GROUP_BANKING_SUCCESS"
export const MANAGE_MERCHANT_GROUP_BANKING_FAIL = "MANAGE_MERCHANT_GROUP_BANKING_FAIL"

// Toggle Merchant Group Banking Default (Set/Unset Default)
export const TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT = "TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT"
export const TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_SUCCESS = "TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_SUCCESS"
export const TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_FAIL = "TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT_FAIL"

// Check Merchant Group Banking Status
export const CHECK_MERCHANT_GROUP_BANKING_STATUS = "CHECK_MERCHANT_GROUP_BANKING_STATUS"
export const CHECK_MERCHANT_GROUP_BANKING_STATUS_SUCCESS = "CHECK_MERCHANT_GROUP_BANKING_STATUS_SUCCESS"
export const CHECK_MERCHANT_GROUP_BANKING_STATUS_FAIL = "CHECK_MERCHANT_GROUP_BANKING_STATUS_FAIL"

// Contact Creation Phase State Management
export const SET_CONTACT_CREATION_STATE = "SET_CONTACT_CREATION_STATE"
export const CLEAR_CONTACT_CREATION_STATE = "CLEAR_CONTACT_CREATION_STATE"

// Delete Merchant Group
export const DELETE_MERCHANT_GROUP = "DELETE_MERCHANT_GROUP"
export const DELETE_MERCHANT_GROUP_SUCCESS = "DELETE_MERCHANT_GROUP_SUCCESS"
export const DELETE_MERCHANT_GROUP_FAIL = "DELETE_MERCHANT_GROUP_FAIL"

// Merchant Group Admin User
export const GET_MERCHANT_GROUP_ADMIN_USER = "GET_MERCHANT_GROUP_ADMIN_USER"
export const GET_MERCHANT_GROUP_ADMIN_USER_SUCCESS = "GET_MERCHANT_GROUP_ADMIN_USER_SUCCESS"
export const GET_MERCHANT_GROUP_ADMIN_USER_FAIL = "GET_MERCHANT_GROUP_ADMIN_USER_FAIL"
export const CLEAR_MERCHANT_GROUP_ADMIN_USER = "CLEAR_MERCHANT_GROUP_ADMIN_USER"

export const CREATE_MERCHANT_GROUP_ADMIN_USER = "CREATE_MERCHANT_GROUP_ADMIN_USER"
export const CREATE_MERCHANT_GROUP_ADMIN_USER_SUCCESS = "CREATE_MERCHANT_GROUP_ADMIN_USER_SUCCESS"
export const CREATE_MERCHANT_GROUP_ADMIN_USER_FAIL = "CREATE_MERCHANT_GROUP_ADMIN_USER_FAIL"
